import { render } from "./ModalError.vue?vue&type=template&id=b1b98c22&scoped=true&ts=true"
import script from "./ModalError.vue?vue&type=script&lang=ts"
export * from "./ModalError.vue?vue&type=script&lang=ts"

import "./ModalError.vue?vue&type=style&index=0&id=b1b98c22&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b98c22"]])

export default __exports__